export default __webpack_public_path__ + "static/media/taperia.66d96fda.jpg";